export default __webpack_public_path__ + "static/6853-6fcbaac3e35d0833111a281f4b49a917.jpg";